export default __webpack_public_path__ + "static/media/icon-info.54f6af0e.svg";